import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getConsent, setConsent } from "@/lib/tracking";

export const CookieBanner = () => {
  const [open, setOpen] = useState(() => getConsent() === null);
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("epl-open-cookies", show);
    return () => window.removeEventListener("epl-open-cookies", show);
  }, []);
  const { pathname } = useLocation();
  if (!open || pathname.startsWith("/admin")) return null;
  const choose = (v) => { setConsent(v); setOpen(false); window.dispatchEvent(new Event("epl-consent-set")); };
  return (
    <div data-testid="cookie-banner" className="fixed z-[60] left-3 right-3 bottom-24 md:bottom-6 md:left-6 md:right-auto md:max-w-md rounded-3xl border border-white/10 bg-[#0f1420]/95 backdrop-blur-xl p-6 shadow-2xl">
      <p className="font-display font-bold text-lg">Cookies & tracking</p>
      <p className="mt-2 text-sm text-slate-400 leading-relaxed">
        We use essential cookies to run this site. With your permission we also use Meta and Google cookies to measure our advertising.
        We never share children's or medical information. <Link to="/privacy" className="accent-text underline">Privacy Policy</Link>
      </p>
      <div className="mt-5 flex gap-2">
        <button data-testid="cookie-accept" onClick={() => choose("granted")} className="btn-primary !py-3 !px-5 flex-1">Accept</button>
        <button data-testid="cookie-decline" onClick={() => choose("denied")} className="btn-ghost !py-3 !px-5 flex-1">Decline</button>
      </div>
    </div>
  );
};
